export const MODULE_NAME = 'PhysicianResources'
